import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import MemecoinPage from "./routes/MemecoinPage";
import FeeshKees from "./routes/FeeshKees";
import Whitepaper from "./routes/Whitepaper";
import "./App.css";

const App = () => {
  const location = useLocation();
  console.log("Current path:", location.pathname);

  return (
    <Routes>
      <Route path="/" element={<MemecoinPage />} />
      <Route path="/kiss" element={<FeeshKees />} />
      <Route path="/whitepaper" element={<Whitepaper />} />
    </Routes>
  );
};

export default App;
